// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `li.item-menu-divider {
  height: 1px;
  margin: 16px 0;
  background-color: var(--ion-color-primary-shade);
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/menu/item-divider/item-divider.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,cAAA;EACA,gDAAA;AACF","sourcesContent":["li.item-menu-divider {\n  height: 1px;\n  margin: 16px 0;\n  background-color: var(--ion-color-primary-shade);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
